export const screens = {
  lobby: 'lobby',
  intro: 'intro'
}
